module.exports = __webpack_public_path__ + "static/media/banner_workshopDesenvolvimentoTI.e0ce5f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/DesenvolvimentoTI/banner_workshopDesenvolvimentoTI.png
// module id = 243
// module chunks = 0